import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneAllCases';
const QS_TYPE: QueryStateSchema['type'] = 'allCases';

export const useOpenAllCasesPane = (): ((args: { allCases: string }) => void) => {
  const [allCasesDeprecated, setAllCases] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (allCasesDeprecated) {
      setAllCases(null);
      setState(backwardsCompatabilityFactory({ id: allCasesDeprecated, type: QS_TYPE }));
    }
  }, [allCasesDeprecated]);

  return ({ allCases }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: allCases,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
